<div class="emsp-layout">
  <div
    class="emsp-frame"
    *ngIf="isExternalMAMEditor == false || gatewayProviders.length > 0"
  >
    <div class="text-wrapper">Installed MAM platforms</div>
    <div class="emsp-providers">
      <external-mam-gateways-card
        *ngFor="let gateway of gatewayProviders"
        [service]="getServiceById(gateway.externalMAMType)"
        [gateway]="gateway"
        [isExternalMAMEditor]="isExternalMAMEditor"
        (goToSearch)="goToSearch(gateway.id)"
        (goToEdit)="goToEdit(gateway.externalMAMType, gateway.id)"
      >
      </external-mam-gateways-card>
    </div>
  </div>
  <div class="emsp-frame" *ngIf="isExternalMAMEditor">
    <div class="text-wrapper">Available MAM platforms</div>
    <div class="emsp-providers">
      <external-mam-providers-card
        *ngFor="let provider of serviceProviders"
        [provider]="provider"
        (goTo)="goToSetup(provider.id)"
      >
      </external-mam-providers-card>
    </div>
  </div>
</div>
